import { get } from 'lodash';
import Vue from 'vue';

export default {
  setProp(state, payload) {
    // split key by the last period .
    // example -> we call mutation commit('setProp', { key: 'state.object.property', value: 1})
    // which is intended to update state's "state.object" "property" value
    // splitting the key will produce following result
    // path = "state.object"
    // key = "property"
    const [path, key] = payload.key.split(/\.(?=[^.]+$)/);
    // here we use Vue.set to update the state
    // we get the object under the path value i.e. "state.object" using lodash get method
    // then we set with Vue.set property value
    if (!key) {
      Vue.set(state, path, payload.value);
    } else {
      Vue.set(get(state, path), key, payload.value);
    }
  },
  addAlert(state, payload) {
    state.alertState[payload.origin] = {
      showAlert: payload.showAlert,
      message: payload.message,
    };
    state.alerts.unshift(payload);
  },
  clearAlerts(state) {
    state.alerts = [];
  },
  showBadge(state, show) {
    state.showBadge = show;
  },
};
